import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, withHandlers, withState, withProps } from 'recompose';
import IconButton from 'material-ui/IconButton';
import Avatar from 'material-ui/Avatar';
import LogOut from 'material-ui/svg-icons/action/power-settings-new';
import { get } from 'lodash';

import Sidebar from '@inqool/uas-web-core/es/components/app/Sidebar';
import * as storage from '@inqool/uas-web-core/es/utils/storage';

import Breadcrumb from '@components/sidebar/Breadcrumb';
import { sidebarItems } from '@components/sidebar/sidebarItems';
import { Dialog } from 'material-ui';
import { UserProfilesModal } from './userProfiles/UserProfilesModal';
import { ModalButton } from '@components/modalButton/ModalButton';
import { GlobalSearchModal } from './globalSearch/GlobalSearchModal';
import { getConfigurationContext } from '@components/provider/configuration/ConfigurationProvider';
import { filterByModulesAndPermissions } from '@utils/utils';
import { withConfiguration } from '@components/hoc/withConfiguration';

const logo = require('./../../assets/img/logo.svg');

const enhance = compose<any, any>(
  withRouter,
  withState('open', 'setOpen', true),
  withState('showLogIn', 'handleShowLogIn', false),
  withState('items', 'setItems', []),
  withProps(({ items, setItems }) => {
    const {
      config: { modules }
    } = getConfigurationContext();

    const newItems = filterByModulesAndPermissions(modules, sidebarItems('#39579e'));

    if (newItems.length !== items.length) {
      setItems(newItems);
    }

    return {
      items,
      userName: storage.get('user'),
      modules
    };
  }),
  withHandlers({
    isActive: ({ location }) => path => location.pathname === path,
    onClick: ({ history }) => ({ path }) => {
      history.push(path);
    }
  }),
  connect(({ app: { breadcrumbs } }: any) => ({ breadcrumbs })),
  withConfiguration({})
);

const AppBar = ({ history, userName, showLogIn, handleShowLogIn, modules, config }) => {
  const isTest = get(config, 'extensions.environment') === 'test';
  const isLoginBasic = get(config, 'extensions.login') === 'basic';
  return (
    <div
      className="appbar"
      style={{
        background: isTest ? '#faddc6' : '#f5f5f5',
        borderBottom: '1px solid rgb(224, 224, 224)',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1000,
        height: 48,
        color: 'white'
      }}
    >
      {isTest && (
        <div
          style={{
            float: 'left',
            color: '#000',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '15px'
          }}
        >
          Testovací prostředí
        </div>
      )}
      <div style={{ float: 'right', height: '50px', display: 'flex', alignItems: 'center' }}>
        {userName && (
          <React.Fragment>
            <ModalButton
              label="Globální vyhledávaní"
              style={{ marginRight: '50px' }}
              ModalComponent={GlobalSearchModal}
              modules={modules}
            />
            <div style={{ color: 'black', padding: '0 10px', cursor: 'pointer' }} onClick={() => handleShowLogIn(true)}>
              <Avatar style={{ textTransform: 'uppercase' }} backgroundColor="#ec7d23">
                {userName.charAt(0)}
              </Avatar>
              <span style={{ paddingLeft: '10px' }}>{userName}</span>
            </div>
          </React.Fragment>
        )}
        <IconButton style={{ marginLeft: '20px' }} onClick={() => history.push('/logout')}>
          <LogOut />
        </IconButton>
      </div>
      <Dialog
        repositionOnUpdate={false}
        style={{ paddingTop: '20vh' }}
        contentStyle={{
          paddingTop: 10,
          width: '50vw',
          transform: 'none'
        }}
        open={showLogIn}
        onRequestClose={() => handleShowLogIn(false)}
      >
        <UserProfilesModal closeItem={() => handleShowLogIn(false)} isLoginBasic={isLoginBasic} />
      </Dialog>
    </div>
  );
};
export default enhance(({ children, userName, showLogIn, handleShowLogIn, items, modules, config, ...rest }) => (
  <>
    <AppBar
      history={rest.history}
      userName={userName}
      showLogIn={showLogIn}
      handleShowLogIn={handleShowLogIn}
      modules={modules}
      config={config}
    />
    <Sidebar
      {...rest}
      BreadcrumbsItem={Breadcrumb}
      appBarHeight={48}
      logo={logo}
      logoStyle={{
        wrapperWidth: 0,
        paddingLeft: 0,
        paddingRight: 0,
        width: '100%',
        boxSizing: 'border-box'
      }}
      open={rest.open}
      AppBar={AppBar}
      items={items}
      orientation="vertical"
      togglable={false}
      singleItemToggle={false}
      showBreadCrumbs={true}
      containerPadding={20}
      withRightIconsOnToggle={true}
    >
      {children}
    </Sidebar>
  </>
));



// WEBPACK FOOTER //
// ./src/components/sidebar/Sidebar.tsx